<template>
  <span class="upload transtant-input">
    <el-button @click="visible = true" type="primary">上传</el-button>
    <el-dialog v-drag:common title="文件上传" :visible.sync="visible">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        size="mini"
        label-width="80px"
      >
        <el-form-item label="文件类型">
          <el-radio-group v-model="form.type">
            <el-radio label="1">PDF</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数据文件" required>
          <el-upload
            ref="upload"
            :action="action"
            :auto-upload="false"
            :data="uploadParam"
            :on-success="uploadSuccess"
            accept=".pdf"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件标题" prop="title" style="width: 460px">
          <el-input v-model="form.title" :maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="文件摘要" prop="introduction" style="width: 460px">
          <el-input
            type="textarea"
            v-model="form.introduction"
            :maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="文件分类" prop="fileType" style="width: 460px">
          <el-select
            v-model="form.fileType"
            placeholder="请选择活动区域"
            style="width: 380px"
          >
            <el-option label="政策信息" value="1" name="fileType"></el-option>
            <el-option label="行业信息" value="2" name="fileType"></el-option>
            <el-option label="前瞻技术" value="3" name="fileType"></el-option>
            <el-option label="招投标信息" value="4" name="fileType"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件来源" prop="source" style="width: 460px">
          <el-input
            type="textarea"
            v-model="form.source"
            :maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布日期" prop="timestamp" style="width: 460px">
          <el-date-picker
            style="width: 380px"
            placeholder="请选择"
            v-model="form.timestamp"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { getToken } from '@/utils/index';

const DEFAULT_FORM = {
  type: '1',
  fileType: '1',
  title: '',
  introduction: '',
  source: '',
  timestamp: ''
};

export default {
  props: ['data'],
  data() {
    return {
      action: `${process.env.VUE_APP_API_HOST}/windfarm/news/uploadFile`,
      visible: false,
      fileList: [],
      form: { ...DEFAULT_FORM },
      rules: {
        fileType: [{ required: true, message: '请选择' }],
        title: [{ required: true, message: '请输入1-50个字符' }],
        introduction: [{ required: true, message: '请输入1-200个字符' }],
        source: [{ required: true, message: '请输入1-50个字符' }],
        timestamp: [{ required: true, message: '请选择日期' }]
      }
    };
  },
  computed: {
    uploadParam() {
      const param = { ...this.form, type: null, apiKey: getToken() };
      if (param.timestamp) {
        param.timestamp = this.$moment(param.timestamp).format(
          'YYYY-MM-DD HH:MM:SS'
        );
      }
      return param;
    }
  },
  methods: {
    clickItem(item) {
      this.$router.push(`/industry/detail/${item.newsId}`);
    },
    save() {
      this.$refs.form.validate(valid => {
        if (isEmpty(this.$refs.upload.uploadFiles)) {
          this.$message({
            message: '请选择文件',
            type: 'error'
          });
          return;
        }
        if (valid) {
          this.$refs.upload.submit();
        } else {
          return false;
        }
      });
    },
    uploadSuccess() {
      this.visible = false;
      this.form = { ...DEFAULT_FORM };
      this.$refs.upload.clearFiles();
      this.$message({
        message: '上传成功',
        type: 'success'
      });
      location.reload();
    }
  }
};
</script>

<style lang="less" scoped>
.upload {
  margin-left: 20px;
}

/deep/.el-form-item {
  .el-form-item__label {
    color: #fff;
  }

  .el-textarea__inner {
    background-color: transparent;
    color: #fff;
  }
}
/deep/.el-dialog {
  width: 40%;
}
</style>
